import {numberCellFormatter, sortByAbs} from "./analytics-helpers";

export const defaultPriceWatcherDefinition = {
  name: null,
  description: "",
  executionType: "SERVICE",
  configuration: {
    use_debug_logs: false,
    send_diffs_only: true,
    ignore_empty_ticks: true,
    use_utc_time: true,
    ping_interval: 3,
    max_dsdp_join_delay: 60,
    dsdp_expire_time: 60,
    watched_symbols: [],
    log_prices_in_stats: false,
    stats_interval: 3600,
  },
};
export const defaultDefinition = {
  // id: "",
  name: null,
  description: "",
  executionType: "PROCESS",
  configuration: {
    ConnectionPingCycle: 1000,
    MaxReconnectRetries: 2147483647,
    ReconnectTime: 10000,
    ServerName: "",
    CompressMessages: true,
    EnableRecoveryMode: false,
    Analytics: {
      AcceptableDeviationFromUtc: 50400,
      AcceptableDailyReportDeviationPercentage: 20,
      DeleteOldUsersFromDb: false,
      DailyProfitSynchronizationCycle: 900,
      CalculationCurrency: "USD",
      DailyReportsFetchOffsetTime: 20,
      DefaultPrefetchDailyReports: 2,
      Enabled: true,
      ExcludeServices: [],
      ExcludeLogins: [],
      ExecutionMappings: [],
      ExecutionPeriodTime: 5,
      GroupMask: "*",
      GroupSummaryItemsBySymbol: true,
      InitialSynchronizationTimestamp: 0,
      IgnoreEmptyDailyReports: true,
      MinifyMessages: false,
      PrivacyPolicyAccepted: false,
      PositionsDispatchCycle: 5,
      PositionsPersistenceCycle: 10,
      RecalculateTradeProfit: false,
      SymbolSplitPattern: "",
      SynchronizationCycle: 15000,
      TicksSynchronizationCycle: 1800000,
      SecondaryCalculationCurrencies: [],
      CalculationCurrenciesSuffixes: [],
      IntermediateCurrencies: ['USD'],
      MissingSymbolsToLiveTicksSynchronizationCycleRatio: 12,
      TradesBatchSize: 1000,
      TradesLingerTime: 5000,
      UserIdExtractRegex: "",
      UserSynchronizationCycle: 900,
      GetLatestEodPricesFromApi: true,
      SymbolsMultipliers: {},
      CustomUserExclusion: "",
      EodFloatingPnlOffsetTimes: {
        Sunday: {From: 300, To: 1800},
        Monday: {From: 300, To: 1800},
        Tuesday: {From: 300, To: 1800},
        Wednesday: {From: 300, To: 1800},
        Thursday: {From: 300, To: 1800},
        Friday: {From: 300, To: 1800},
        Saturday: {From: 300, To: 1800},
      },
      JournalFilters: [],
      JournalSynchronizationCycle: 3600,
      DefaultPrefetchJournal: 1,
      JournalFetchOffsetTime: 45,
      GroupEodFloatingPnls: false,
      SymbolsPersistenceCycle: 3600,
      UseJournal: true,
      UseDynamicData: true,
      PositionsPreparedStatementLimit: 10000,
      CalculationCurrencyDigits: 2,
      LiveTicksSynchronizationCycle: 5000,
      IgnoreUnmodifiedUsers: false,
      UsersPreparedStatementLimit: 10000
    },
    PriceGuard: {
      Enabled: true,
      WatchedSymbols: [],
      PriceWatcherSymbols: [],
      CycleTime: 1000,
    },
  },
};

export const defaultEventRule = {
  eventRule: {
    application: "",
    description: "",
    enabled: false,
    expression: "",
    id: 0,
    name: "",
    namespace: "",
    priority: 0,
  },
};

export const defaultApplication = {
  id: 0,
  name: "",
  description: "",
  code: "",
};

export const defaultLayout = [
  {
    x: 0,
    y: 0,
    w: 18,
    h: 6,
    i: "0",
    tableName: "summary",
  },
  {x: 0, y: 0, w: 9, h: 5, i: "1", tableName: "exposure"},
];

export const defaultANStateInstance = {
  setInstance: (itemId) => {
    return {
      id: itemId,
      layout: [
        Object.assign({}, defaultLayout[0]),
        Object.assign({}, defaultLayout[1]),
      ],
      exposure: {},
      summary: {},
    };
  },
};

export const defaultSettings = {
  device: "Desktop",
  general: {
    dashboard: {
      url: "",
      secret_key: "",
      exp: null,
      refresh_time: 15,
      number: null,
    },
    notifications: {
      stack: false,
      enable: true,
      updateSameType: true,
      renotify: true,
      success: true,
      info: true,
      error: true,
      warning: true,
    },
    sse: {
      pingAbsenceLimit: 10000,
      logSSEState: false,
    },
  },
  applications: {
    priceguard: {
      dataExpirationCycle: 30,
      removeExpiredDataAfter: 30,
      priceOldAfter: 30,
    },
    analytics: {
      useDigitsField: false,
      positionLogs: false,
    },
    pricewatcher: {
      keepPreviousTimeFrameData: false,
      dataAbsenceWarning: 120,
    },
  },
  user: {},
  applicationState: {
    analytics: {
      // These are commented because completeSettingsBackwardCompatibility() in App.vue doesnt inclue creating
      // inner properties and so they have to be added by the components themselves
      instances: [],
      mergedInstances: [],
      selectedInstance: null,
      showingExposureTable: true,
      showingSummaryFooter: false,
    },
    priceguard: {
      mute: false,
      expiring: false,
      ignoredItems: [],
      sort: "Newest",
    },
    tradewatcher: {
      mute: false,
      navBarPin: false,
    },
    mute: false,
    dark: true,
  },
};

export const TWDaysAndTiming = {
  mon: {
    value: true,
    time: {
      from: {hours: 0, minutes: 0, dayPeriod: "am"},
      to: {hours: 0, minutes: 0, dayPeriod: "am"},
    },
  },
  tue: {
    value: true,
    time: {
      from: {hours: 0, minutes: 0, dayPeriod: "am"},
      to: {hours: 0, minutes: 0, dayPeriod: "am"},
    },
  },
  wed: {
    value: true,
    time: {
      from: {hours: 0, minutes: 0, dayPeriod: "am"},
      to: {hours: 0, minutes: 0, dayPeriod: "am"},
    },
  },
  thu: {
    value: true,
    time: {
      from: {hours: 0, minutes: 0, dayPeriod: "am"},
      to: {hours: 0, minutes: 0, dayPeriod: "am"},
    },
  },
  fri: {
    value: true,
    time: {
      from: {hours: 0, minutes: 0, dayPeriod: "am"},
      to: {hours: 0, minutes: 0, dayPeriod: "am"},
    },
  },
  sat: {
    value: false,
    time: {
      from: {hours: 0, minutes: 0, dayPeriod: "am"},
      to: {hours: 0, minutes: 0, dayPeriod: "am"},
    },
  },
  sun: {
    value: false,
    time: {
      from: {hours: 0, minutes: 0, dayPeriod: "am"},
      to: {hours: 0, minutes: 0, dayPeriod: "am"},
    },
  },
};

export const summaryColumnDefsFoldedNumeric = [
  {
    headerName: "NotionalValue",
    field: "12",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "NetVolume",
    field: "7",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Profit",
    field: "8",
    sortable: true,
    filter: true,
    aggFunc: "sum",
    enableValue: true,
    cellClass: "number",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Swap",
    field: "9",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Commision",
    field: "10",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Symbol",
    field: "0",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreSymbol",
    field: "1",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 1,
  },
  {
    headerName: "Deals",
    field: "13",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    aggFunc: "sum",
  },
  {
    headerName: "BuyVolume",
    field: "3",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "BuyPrice",
    field: "4",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellVolume",
    field: "5",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellPrice",
    field: "6",
    enableValue: true,
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "11",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
];

export const summaryColumnDefsFolded = [
  {
    headerName: "NotionalValue",
    field: "NotionalValue",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "NetVolume",
    field: "NetVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Profit",
    field: "Profit",
    sortable: true,
    filter: true,
    aggFunc: "sum",
    enableValue: true,
    cellClass: "number",

    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Swap",
    field: "Swap",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Commision",
    field: "Commision",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Symbol",
    field: "Symbol",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreSymbol",
    field: "PlainSymbol",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 1,
  },
  {
    headerName: "Deals",
    field: "Count",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    aggFunc: "sum",
  },
  {
    headerName: "BuyVolume",
    field: "BuyVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "BuyPrice",
    field: "BuyPrice",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellVolume",
    field: "SellVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellPrice",
    field: "SellPrice",
    enableValue: true,
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "Book",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
];

export const summaryColumnDefsUnfoldedNumeric = [
  {
    headerName: "Symbol",
    field: "0",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreSymbol",
    field: "1",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 1,
  },
  {
    headerName: "BuyVolume",
    field: "3",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "BuyPrice",
    field: "4",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellVolume",
    field: "5",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellPrice",
    field: "6",
    enableValue: true,
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "NetVolume",
    field: "7",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Profit",
    field: "8",
    sortable: true,
    filter: true,
    aggFunc: "sum",
    enableValue: true,
    cellClass: "number",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Swap",
    field: "9",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Commision",
    field: "10",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "11",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
  {
    headerName: "NotionalValue",
    field: "12",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "PositionId",
    field: "13",
    enableValue: true,
    sortable: true,
  },
  {
    headerName: "Login",
    field: "14",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
  {
    headerName: "Group",
    field: "15",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
];

export const summaryColumnDefsUnfolded = [
  {
    headerName: "NotionalValue",
    field: "NotionalValue",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "NetVolume",
    field: "NetVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Profit",
    field: "Profit",
    sortable: true,
    filter: true,
    aggFunc: "sum",
    enableValue: true,
    cellClass: "number",

    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Swap",
    field: "Swap",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Commision",
    field: "Commision",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Symbol",
    field: "Symbol",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreSymbol",
    field: "PlainSymbol",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 1,
  },
  {
    headerName: "BuyVolume",
    field: "BuyVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "BuyPrice",
    field: "BuyPrice",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellVolume",
    field: "SellVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellPrice",
    field: "SellPrice",
    enableValue: true,
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "Book",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
  {
    headerName: "PositionId",
    field: "PositionId",
    enableValue: true,
    sortable: true,
  },
  {
    headerName: "Login",
    field: "Login",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
  {
    headerName: "Group",
    field: "Group",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
];

export const summaryColumnDefsFoldedMerged = [
  {
    headerName: "NotionalValue",
    field: "NotionalValue",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "NetVolume",
    field: "NetVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Profit",
    field: "Profit",
    sortable: true,
    filter: true,
    aggFunc: "sum",
    enableValue: true,
    cellClass: "number",

    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Swap",
    field: "Swap",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Commision",
    field: "Commision",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Symbol",
    field: "Symbol",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreSymbol",
    field: "PlainSymbol",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 1,
  },
  {
    headerName: "Deals",
    field: "Count",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    aggFunc: "sum",
  },
  {
    headerName: "BuyVolume",
    field: "BuyVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "BuyPrice",
    field: "BuyPrice",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellVolume",
    field: "SellVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellPrice",
    field: "SellPrice",
    enableValue: true,
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "Book",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
  {
    headerName: "Server",
    field: "instanceId",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
];

export const summaryColumnDefsFoldedNumericMerged = [
  {
    headerName: "NotionalValue",
    field: "12",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "NetVolume",
    field: "7",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Profit",
    field: "8",
    sortable: true,
    filter: true,
    aggFunc: "sum",
    enableValue: true,
    cellClass: "number",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Swap",
    field: "9",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Commision",
    field: "10",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Symbol",
    field: "0",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreSymbol",
    field: "1",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 1,
  },
  {
    headerName: "Deals",
    field: "13",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    aggFunc: "sum",
  },
  {
    headerName: "BuyVolume",
    field: "3",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "BuyPrice",
    field: "4",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellVolume",
    field: "5",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellPrice",
    field: "6",
    enableValue: true,
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "11",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
  {
    headerName: "Server",
    field: "15",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
];

export const summaryColumnDefsUnfoldedMerged = [
  {
    headerName: "NotionalValue",
    field: "NotionalValue",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "NetVolume",
    field: "NetVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Profit",
    field: "Profit",
    sortable: true,
    filter: true,
    aggFunc: "sum",
    enableValue: true,
    cellClass: "number",

    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Swap",
    field: "Swap",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Commision",
    field: "Commision",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Symbol",
    field: "Symbol",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreSymbol",
    field: "PlainSymbol",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 1,
  },
  {
    headerName: "BuyVolume",
    field: "BuyVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "BuyPrice",
    field: "BuyPrice",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellVolume",
    field: "SellVolume",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellPrice",
    field: "SellPrice",
    enableValue: true,
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "Book",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
  {
    headerName: "PositionId",
    field: "PositionId",
    enableValue: true,
    sortable: true,
  },
  {
    headerName: "Login",
    field: "Login",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
  {
    headerName: "Group",
    field: "Group",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
  {
    headerName: "Server",
    field: "instanceId",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
];

export const summaryColumnDefsUnfoldedNumericMerged = [
  {
    headerName: "Symbol",
    field: "0",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreSymbol",
    field: "1",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 1,
  },
  {
    headerName: "BuyVolume",
    field: "3",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "BuyPrice",
    field: "4",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellVolume",
    field: "5",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "SellPrice",
    field: "6",
    enableValue: true,
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "NetVolume",
    field: "7",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Profit",
    field: "8",
    sortable: true,
    filter: true,
    aggFunc: "sum",
    enableValue: true,
    cellClass: "number",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "Swap",
    field: "9",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Commision",
    field: "10",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "11",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
  {
    headerName: "NotionalValue",
    field: "12",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
    comparator: sortByAbs,
  },
  {
    headerName: "PositionId",
    field: "13",
    enableValue: true,
    sortable: true,
  },
  {
    headerName: "Login",
    field: "14",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
  {
    headerName: "Group",
    field: "15",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
  {
    headerName: "Server",
    field: "16",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
];

export const exposureColumnDefsNumeric = [
  {
    headerName: "Asset",
    field: "0",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreAsset",
    field: "1",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "Clients",
    field: "3",
    sortable: true,
    valueFormatter: numberCellFormatter,
  },
  {headerName: "Rate", field: "4", sortable: true},
  {
    headerName: "NetTotal",
    field: "5",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Canonical Net Total",
    field: "8",
    sortable: true,
    filter: true,
    enablePivot: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "6",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
  {
    headerName: "Type",
    field: "7",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  // {
  //   headerName: "Server",
  //   field: "9",
  //   enableValue: true,
  //   enableRowGroup: true,
  //   enablePivot: true,
  //   sortable: true,
  // }
];

export const exposureColumnDefsNumericMerged = [
  {
    headerName: "Asset",
    field: "0",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreAsset",
    field: "1",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "Clients",
    field: "3",
    sortable: true,
    valueFormatter: numberCellFormatter,
  },
  {headerName: "Rate", field: "4", sortable: true},
  {
    headerName: "NetTotal",
    field: "5",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Canonical Net Total",
    field: "8",
    sortable: true,
    filter: true,
    enablePivot: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "6",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
  {
    headerName: "Type",
    field: "7",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "Server",
    field: "9",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
];

export const exposureColumnDefs = [
  {
    headerName: "Asset",
    field: "Asset",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "Clients",
    field: "Clients",
    sortable: true,
    valueFormatter: numberCellFormatter,
  },
  {headerName: "Rate", field: "Rate", sortable: true},
  {
    headerName: "NetTotal",
    field: "NetTotal",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Canonical Net Total",
    field: "CanonicalNetTotal",
    sortable: true,
    filter: true,
    enablePivot: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "Book",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
  {
    headerName: "Type",
    field: "Type",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreAsset",
    field: "CoreAsset",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
];

export const exposureColumnDefsMerged = [
  {
    headerName: "Asset",
    field: "Asset",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "Clients",
    field: "Clients",
    sortable: true,
    valueFormatter: numberCellFormatter,
  },
  {headerName: "Rate", field: "Rate", sortable: true},
  {
    headerName: "NetTotal",
    field: "NetTotal",
    sortable: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Canonical Net Total",
    field: "CanonicalNetTotal",
    sortable: true,
    filter: true,
    enablePivot: true,
    aggFunc: "sum",
    valueFormatter: numberCellFormatter,
  },
  {
    headerName: "Book",
    field: "Book",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
    rowGroupIndex: 0,
  },
  {
    headerName: "Type",
    field: "Type",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "CoreAsset",
    field: "CoreAsset",
    sortable: true,
    filter: true,
    enableRowGroup: true,
    enablePivot: true,
  },
  {
    headerName: "Server",
    field: "instanceId",
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
  },
];

export const ANPositionKeys = {
  numeric: {
    PositionId: "0",
    Asset: "0",
    Symbol: "0",
    PlainSymbol: "1",
    Digits: "2",
    Count: "13",
    BuyVolume: "3",
    BuyPrice: "4",
    SellVolume: "5",
    SellPrice: "6",
    NetVolume: "7",
    Profit: "8",
    Swap: "9",
    Commision: "10",
    Book: "11",
    NotionalValue: "12",
  },
  // numeric: {
  //   PositionId: "0",
  //   Asset: "0",
  //   Symbol: "0",
  //   PlainSymbol: "1",
  //   Count: "13",
  //   BuyVolume: "3",
  //   BuyPrice: "4",
  //   SellVolume: "5",
  //   SellPrice: "6",
  //   NetVolume: "7",
  //   Profit: "8",
  //   Swap: "9",
  //   Commision: "10",
  //   Book: "11",
  //   NotionalValue: "12",
  // },
  strings: {
    PositionId: "PositionId",
    Digits: "Digits",
    Asset: "Asset",
    Symbol: "Symbol",
    PlainSymbol: "PlainSymbol",
    Count: "Count",
    BuyVolume: "BuyVolume",
    BuyPrice: "BuyPrice",
    SellVolume: "SellVolume",
    SellPrice: "SellPrice",
    NetVolume: "NetVolume",
    Profit: "Profit",
    Swap: "Swap",
    Commision: "Commision",
    NotionalValue: "NotionalValue",
    Book: "Book",
  },
};

export const defaultAlertTWType = {
  arguments: [],
  skipQueryValidation: false,
  description: "Alert description",
  id: 0,
  isDistributedQuery: false,
  message: {
    columnNames: [],
    columnNumbers: [],
    format:
        "Login ‘%s’ has been detected with ‘%s’ high-frequency trades. Edit this text",
  },
  name: "New Alert",
  query: "select count(*) from trades where duration < 1 and sourceid in (?)",
  scope: "postgres",
};

export const defaultNewUser = {
  email: "",
  enabled: true,
  password: "",
  roles: [],
  username: "",
};
export const defaultAlertCard = {
  name: "",
  sourceIds: [],
  arguments: null,
  daysOfWeek: JSON.parse(JSON.stringify(TWDaysAndTiming)),
  importance: "CONTINUOUS",
  description: "",
  notificationType: "CONTINUOUS",
  specifications: {
    dynamicThreshold: null,
  }
};

export const defaultDynamicThreshold = {
  enable: false,
  nextLevel: 0,
  argumentName: "",
  changeLevelType: "AMOUNT",
  changeDirectionAlert: false
};
export const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const defaultChart = {
  name: "",
  symbol: "",
  watchers: [],
  type: 0,
};

export const defaultChartOption = {
  title: {
    text: "",
  },
  legend: {
    data: [],
    textStyle: {
      color: "white",
    },
  },
  tooltip: {
    trigger: "axis",
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: "none",
      },
      // dataView: { readOnly: false },
      // magicType: { type: ["line", "bar"] },
      restore: {},
      // saveAsImage: {},
    },
    right: 20,
    top: 12,
  },
  grid: {
    left: 50,
    right: 50,
    bottom: 50,
  },
  xAxis: {
    // axisTick: {
    //   show: true,
    //   alignWithLabel: true,
    //   lineStyle: {
    //     color: "red",
    //   }
    // },
    type: "time",
    splitLine: {
      show: false,
      lineStyle: {
        color: "grey",
      },
    },
    axisLabel: {fontSize: "12", color: "#fff"},
  },
  yAxis: {
    type: "value",
    // max: 3,
    axisLabel: {fontSize: "12", color: "#fff"},
    splitLine: {
      // show: true,
      lineStyle: {
        color: "rgba(255, 255, 255, 0.12)",
      },
    },
  },
  dataZoom: [
    {
      type: "inside",
      throttle: 50,
    },
  ],
  series: [],
};

export const defaultChartZoom = [
  {
    id: "dataZoomX",
    disabled: true,
    type: "inside",
    xAxisIndex: [0],
    minSpan: 0.7,
    showDetail: false,
  },
  {
    id: "dataZoomY",
    disabled: true,
    type: "inside",
    minSpan: 0.7,
    yAxisIndex: [0],
    showDetail: false,
  },
];

export const defaultChartSeries = {
  name: "",
  type: "line",
  smooth: true,
  symbol: "circle",
  showSymbol: false,
  sampling: "average",
  lastUpdate: null,
  // itemStyle: {
  //   color: "#ebdb00",
  // },
  data: [],
};

export const executionTypes = [
  {value: "PROCESS", text: "Process"},
  {value: "SERVICE", text: "Service"},
  {value: "API", text: "API", disabled: true},
];

export const serverVersions = {
  MT4: "MT4",
  MT5: "MT5",
  MTT: "MTT",
  MTC: "MTC",
}

export const encryptionMethods = [
  "NONE_OTHER",
  "PKCS",
  "DES",
  "PKCS_DES",
  "PGP_DES",
  "PGP_DES_MD5",
  "PEM_DES_MD5",
]

export const channelMeta = [
  {
    name: 'SMS',
    value: 'sms',
    id: 1,
    description: 'Receive a notification via SMS on the registered mobile phone number',
  },
  {
    name: 'WhatsApp',
    value: 'whatsapp',
    id: 2,
    description: 'Receive a notification via the WhatsApp messaging application'
  },
  {
    name: 'Email',
    value: 'email',
    id: 3,
    description: 'Receive a notification via Email'
  },
  {
    name: 'Slack',
    value: 'slack',
    id: 4,
    description: 'Receive a notification in Slack'
  }
]

export const channelTypeNames = {
  "sms": "SMS",
  "whatsapp": "WhatsApp",
  "email": "Email",
  "slack": "Slack"
}